import React from "react";

import Checkbox from "ds/Checkbox";

import { FormInputPropType } from "../type";

const FormSwitchInput = (config: FormInputPropType) => {
  return (
    <Checkbox
      required={config.required}
      forId={config.id}
      id={config.id}
      isValid
      label={config.label}
      checked={config.value}
      onCheckedChanged={checked => {
        config?.onChange?.({
          target: { type: "checkbox", checked: checked, name: config.name }
        });
      }}
    />
  );
};

export default FormSwitchInput;
